<template>
  <EquipmentRow
    :key="`${equipment.r_step_up_transformer?.id}`"
    data-cy="up-trans-row-equipment-row"
  >
    <template #left> </template>

    <template #default="{ toggle }">
      <AddRemoveButtons
        :hide-add-below="true"
        :disable-remove="!equipment.up_trans_id"
        data-cy="up-trans-row-add-remove-buttons"
        @remove="
          equipmentForm.update({
            r_step_up_transformer: null,
            up_trans_id: null
          })
        "
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            :rule-names="[
              'up_trans_obsolete',
              'min_secondary_voltage',
              'max_secondary_voltage'
            ]"
            @toggle="toggle"
          >
            <template #header>
              <span data-cy="up-trans-row-panel-header"
                >Step Up Transformer</span
              >
            </template>
            <template v-if="equipment.r_step_up_transformer" #trigger>
              <span data-cy="up-trans-row-panel-trigger">{{
                computeUpTransLabel(equipment.r_step_up_transformer)
              }}</span>
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }">
      <StepUpTransformerSearchView
        :is-admin="false"
        data-cy="up-trans-row-search-view"
        @select="handleStepUpTransformerSelect($event, toggle)"
      />
    </template>
    <template #right>
      <div class="flex flex-column" data-cy="up-trans-row-right">
        <span class="body-4 mb-1" data-cy="up-trans-row-right-tap-range"
          >Tap Range</span
        >
        <span class="numeral-2" data-cy="up-trans-row-right-voltage-range">
          {{ equipment.r_step_up_transformer?.min_secondary_voltage }}
          -
          {{ equipment.r_step_up_transformer?.max_secondary_voltage }}
        </span>
      </div>
    </template>
  </EquipmentRow>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import { computeUpTransLabel } from "@/models/equipment/step_up_transformer/properties";
import { equipmentFormKey } from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import { injectStrict } from "@/utils/utils";
import StepUpTransformerSearchView from "@/components/equipment/step_up_transformers/StepUpTransformerSearchView.vue";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import type { Step_Up_Transformers } from "gql/api";

const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

provide(
  "selected-equipment-id",
  computed(() => equipment.value.r_step_up_transformer?.id)
);

function handleStepUpTransformerSelect(
  stepUpTransformer: Step_Up_Transformers,
  toggle: () => void
) {
  toggle();
  equipmentForm.update({
    r_step_up_transformer: stepUpTransformer,
    up_trans_id: stepUpTransformer?.id
  });
}
</script>
